import {
  aikaStringShort,
  formattedPhoneString,
  isNumber,
  kloString,
  pvmString,
  pvmStringLong,
} from "src/components/js/statics1";
import keikkaClass from "../keikka/keikkaClass";
import keikkaLaskuClass from "./keikkaLaskuClass";
import toimitusClass from "../toimitus/toimitusClass";

import { disallowedKeywords } from "src/components/eval/KeikkaEval/components/keikkaEval_constants";
import { keikkaEval_returnMessage } from "src/components/eval/KeikkaEval/components/keikkaEval_returnMessage";
import tarjousClass from "../tarjous/tarjousClass";

const COMMENT_REGEX = /\/\*[\s\S]*?\*\/|([^:]|^)\/\/.*$/gm;
const NEWLINE_REGEX = /\n/g;

export default function keikkaEval(
  expression, // comments are removed from expression before evaluation (/* */)
  tilaus = null,
  lasku = null,
  toimitus = null,
  tarjous = null,
  removeLineBreaksFromResult = false
) {
  // get expression from result if result is given as an expression
  if (expression?.expression) expression = expression.expression;

  // create returnMessage
  const returnMessage = new keikkaEval_returnMessage(expression);

  // check if expression is undefined or null
  if (expression === undefined || expression === null) {
    returnMessage.error.isError = false;
    returnMessage.error.message = "Expression is undefined or null";
    returnMessage.result.num = 0;
    returnMessage.result.bool = true;
    returnMessage.result.string = "";
    return returnMessage;
  }

  // remove comments from expression (/* */)
  if (expression && expression.length > 0) expression = expression?.replace(COMMENT_REGEX, "");

  if (!returnMessage.expressionType.isEval) {
    // if expression is not eval, return it as it does not need to be evaluated
    const _expressionIsNumber = checkIfNumber(expression);
    if (_expressionIsNumber.success) {
      return _expressionIsNumber;
    }
    return returnMessage;
  }
  // get text between { and } and evaluate them
  const regex = /{([^}]+)}/g;
  const matches = expression.match(regex);
  if (!matches) {
    returnMessage.error.isError = true;
    returnMessage.error.message = "No matches between { and }";
    returnMessage.result.num = 0;
    returnMessage.result.bool = false;
    returnMessage.result.string = expression?.toString();
    if (removeLineBreaksFromResult)
      returnMessage.result.string = removeLinebreaks(returnMessage.result.string);
    return returnMessage;
  }
  let returnString = expression;
  // create objects if not given
  if (!tilaus || (tilaus?.keikkaId == undefined && tilaus?.palkkiId === undefined))
    tilaus = new keikkaClass(0, 0);
  if (!lasku || lasku?.keikkaId === undefined) lasku = new keikkaLaskuClass();
  if (!toimitus || toimitus?.keikkaId === undefined) toimitus = new toimitusClass();
  if (!tarjous || tarjous?.tarjousId === undefined) tarjous = new tarjousClass();

  let _evalResult;
  for (const match of matches) {
    const key = match.substring(1, match.length - 1);
    _evalResult = _keikkaEval(key, tilaus, lasku, toimitus, tarjous);
    if (_evalResult.error.isError || !_evalResult.success) {
      returnMessage.success = false;
      returnMessage.error.isError = true;
      returnMessage.error.message = _evalResult.error.message;
      returnMessage.result.num = 0;
      returnMessage.result.bool = false;
      returnMessage.result.string = expression?.toString();
      if (removeLineBreaksFromResult)
        returnMessage.result.string = removeLinebreaks(returnMessage.result.string);
      return returnMessage;
    }
    returnMessage.resultType = _evalResult.resultType;
    const value = _evalResult.result.string;
    returnString = returnString.replace(match, value); //.replace(NEWLINE_REGEX, "").trim();
    returnMessage.result.num = _evalResult.result.num;
    returnMessage.result.bool = returnString > 0 || returnString === "true";
  }
  if (!_evalResult.success) return _evalResult;

  returnMessage.result.string = returnString?.toString();
  if (removeLineBreaksFromResult)
    returnMessage.result.string = removeLinebreaks(returnMessage.result.string);
  returnMessage.success = true;
  return returnMessage;
}

function checkIfNumber(expression) {
  const returnMessage = new keikkaEval_returnMessage(expression);
  if (isNumber(expression)) {
    returnMessage.resultType.isNum = true;
    returnMessage.resultType.isBool = true;
    returnMessage.success = true;
    returnMessage.result.num = Number(expression);
    returnMessage.result.bool = Number(expression) > 0;
    returnMessage.result.string = expression?.toString();
    return returnMessage;
  } else {
    returnMessage.error.isError = true;
    returnMessage.error.message = "Not a number";
    returnMessage.result.num = 0;
    returnMessage.result.bool = false;
    returnMessage.success = false;
    return returnMessage;

    // return { success: false, error: { message: "Not a number" } };
  }
}

/* eslint-disable no-unused-vars */
function _keikkaEval(expression, tilaus, lasku = null, toimitus = null, tarjous = null) {
  const _expressionIsNumber = checkIfNumber(expression);
  if (_expressionIsNumber.success) {
    return _expressionIsNumber;
  }

  const returnMessage = new keikkaEval_returnMessage(expression);

  const keikka = tilaus;
  const keikkaData = tilaus;
  const laskuData = lasku;
  const toimitusData = toimitus;
  const tarjousData = tarjous;

  try {
    // convert expression to string
    if (typeof expression !== "string") expression = expression?.toString();

    // check for disallowed keywords
    for (const keyword of disallowedKeywords) {
      if (expression.includes(keyword)) {
        returnMessage.error.isError = true;
        returnMessage.error.message = "Disallowed keyword: " + keyword;
        return returnMessage;
      }
    }
    // replace keywords
    // using eslint-disable no-unused-vars below to avoid warnings, these are not unused

    const keikkaId = tilaus?.keikkaId || 0;

    // aika
    const _aloitusAika = (tilaus?.pumppu?.aloitusAika || tilaus?.timeStart) ?? null;
    const _lopetusAika = (tilaus?.pumppu?.lopetusAika || tilaus?.timeEnd) ?? null;
    const minuutit =
      _aloitusAika && _lopetusAika ? Math.round((_lopetusAika - _aloitusAika) / 60000) : 0; // kesto in minutes

    const pvmLong = pvmStringLong(_aloitusAika);
    const pvm = pvmString(_aloitusAika);
    const klo = kloString(_aloitusAika);
    const aika1 = aikaStringShort(_aloitusAika);
    const aloitusaika = aika1;
    const aika2 = aikaStringShort(_lopetusAika);
    const lopetusaika = aika2;
    const aika1hour = _aloitusAika?.getHours();
    const aika2hour = _lopetusAika?.getHours();
    const aika1min = _aloitusAika?.getMinutes();
    const aika2min = _lopetusAika?.getMinutes();
    const aika1dec = aika1hour + aika1min / 60;
    const aika2dec = aika2hour + aika2min / 60;
    const aika1yy = _aloitusAika?.getFullYear();
    const aika2yy = _lopetusAika?.getFullYear();
    const aika1kk = _aloitusAika?.getMonth() + 1;
    const aika2kk = _lopetusAika?.getMonth() + 1;
    const aika1pv = _aloitusAika?.getDate();
    const aika2pv = _lopetusAika?.getDate();
    const tunnit = Math.round(((tilaus?.pumppu?.pumppuKesto ?? 0) / 60) * 100) / 100;
    const työaika = tunnit;

    // pumpputoimitus
    const pumppuKm = Math.round(
      ((tilaus?.pumppuToimittaja?.sijaintiMatkaM || tilaus?.pumppuMatkaM) ?? 0) / 1000
    );
    const pumppuToimittaja = tilaus?.pumppuToimittaja?.asiakasNimi || tilaus?.pumppuAsiakasNimi;
    const rekNo =
      tilaus?.pumppu?.vehicle?.vehicleRegNo || tilaus?.vehicles?.[0]?.vehicleRegNo || "";
    const autoNo = tilaus?.pumppu?.vehicle?.vehicleNo || tilaus?.vehicles?.[0]?.vehicleNo || "";
    const ajoneuvo = tilaus?.pumppu
      ? tilaus?.pumppu?.vehicle?.vehicleTypeShortName +
        " " +
        tilaus?.pumppu?.vehicle?.vehiclePuomi +
        "m " +
        tilaus?.pumppu?.vehicle?.vehicleRegNo
      : tilaus?.vehicles?.[0]?.vehicleTypeShortName +
        " " +
        tilaus?.vehicles?.[0]?.vehiclePuomi +
        "m " +
        tilaus?.vehicles?.[0]?.vehicleRegNo;
    // pumppari
    const _pumpparit = tilaus?.pumppu?.pumppariList || tilaus?.kuskit || [];
    const pumppariNimi =
      (_pumpparit?.[0]?.personFirstName ?? "") + " " + (_pumpparit?.[0]?.personLastName ?? "");
    const kuljettaja = pumppariNimi;
    const pumppariPuh = formattedPhoneString(_pumpparit?.[0]?.personPhone ?? "");

    // linjan pituus
    const tilausLinja = tilaus?.pumppu?.pumppuLinja || tilaus?.pumppuLinja || "";
    const toimitusLinja = toimitus?.pumppuLinja ?? "";
    const linja = toimitusLinja || tilausLinja;
    const puomi = tilaus?.pumppu?.pumppuPuomi || tilaus?.pumppuPuomi || null;

    // betonitoimitus
    const betoniKm = Math.round(
      (tilaus?.betoniToimittaja?.sijaintiMatkaM || tilaus?.betoniMatkaM || 0) / 1000
    );
    const betoniToimittaja = tilaus?.betoniToimittaja?.asiakasNimi || tilaus?.betoniAsiakasNimi;

    // tilattu betoni
    const tilausM3 = tilaus?.totM3 || tilaus?.m3 || 0;
    const tilausM3h =
      aika2dec - aika1dec > 0 ? Math.round((tilausM3 / (aika2dec - aika1dec)) * 100) / 100 : 0;
    const tilausBetoni1m3 = tilaus?.betoni?.[0]?.m3 || tilaus?.betonit?.[0]?.m3 || 0;
    const tilausBetoni2m3 = tilaus?.betoni?.[1]?.m3 || tilaus?.betonit?.[1]?.m3 || 0;
    const tilausBetoni3m3 = tilaus?.betoni?.[2]?.m3 || tilaus?.betonit?.[2]?.m3 || 0;

    // toimitettu betoni
    const toimitusM3 = toimitus?.totM3 ?? 0;
    const toimitusM3h = Math.round(((tilaus?.totM3 ?? 0) / (aika2dec - aika1dec)) * 100) / 100;
    const toimitusBetoni1m3 = toimitus?.betoni?.[0]?.m3 ?? 0;
    const toimitusBetoni2m3 = toimitus?.betoni?.[1]?.m3 ?? 0;
    const toimitusBetoni3m3 = toimitus?.betoni?.[2]?.m3 ?? 0;

    // betoni (get from toimitus if exists, otherwise tilaus)
    const betoni1id = tilaus?.betoni?.[0]?.keikkaBetoniId || tilaus?.betonit?.[0]?.keikkaBetoniId;
    const betoni2id = tilaus?.betoni?.[1]?.keikkaBetoniId || tilaus?.betonit?.[1]?.keikkaBetoniId;
    const betoni3id = tilaus?.betoni?.[2]?.keikkaBetoniId || tilaus?.betonit?.[2]?.keikkaBetoniId;
    const betoni1 = tilaus?.betoni?.[0]?.betoniString || tilaus?.betonit?.[0]?.betoniString || "";
    const betoni2 = tilaus?.betoni?.[1]?.betoniString || tilaus?.betonit?.[1]?.betoniString || "";
    const betoni3 = tilaus?.betoni?.[2]?.betoniString || tilaus?.betonit?.[2]?.betoniString || "";
    const betoni1m3 = toimitusBetoni1m3 || tilausBetoni1m3;
    const betoni2m3 = toimitusBetoni2m3 || tilausBetoni2m3;
    const betoni3m3 = toimitusBetoni3m3 || tilausBetoni3m3;
    const betoni1m3h = Math.round((betoni1m3 / (aika2dec - aika1dec)) * 100) / 100;
    const betoni2m3h = Math.round((betoni2m3 / (aika2dec - aika1dec)) * 100) / 100;
    const betoni3m3h = Math.round((betoni3m3 / (aika2dec - aika1dec)) * 100) / 100;
    const m3 = betoni1m3 + betoni2m3 + betoni3m3;
    const tehdas =
      tilaus?.betoniToimittaja?.sijainti?.sijaintiNimi || tilaus?.betoniSijaintiNimi || "";

    // asiakas
    const asiakas = tilaus.asiakas;
    const asiakasNimi = asiakas?.asiakasNimi || tilaus?.asiakasNimi || "";
    const asiakasEmail = asiakas?.asiakasContactPersonEmail || tilaus.personEmail || "";
    const asiakasPersonName =
      asiakas?.asiakasContactPersonName ||
      tilaus.personFirstName + " " + tilaus.personLastName ||
      "";
    const asiakasPuh = formattedPhoneString(asiakas?.asiakasContactPersonPhone ?? "");

    // tyomaa
    const tyomaa = tilaus.tyomaa;
    const tyomaaNimi = tyomaa?.tyomaaNimi || tilaus.tyomaaNimi || "";
    const tyomaaOsoite = tyomaa?.tyomaaOsoiteString || tilaus.tyomaaOsoite || "";
    const osoite = tyomaaOsoite;

    // evaluate
    const _result = eval(expression);

    // check if _result can be converted to number
    returnMessage.resultType.isObject = typeof _result === "object";
    returnMessage.resultType.isBool = typeof _result === "boolean";
    returnMessage.resultType.isNum = typeof _result === "number";
    returnMessage.resultType.isString = typeof _result === "string";
    if (isNumber(_result)) returnMessage.resultType.isNumber = true;
    if (returnMessage.resultType.isString) {
      const lowerCase = _result.toLowerCase();
      if (lowerCase === "true" || lowerCase === "false") returnMessage.resultType.isBool = true;
    }
    // set returnMessage
    // check if result is number and set it to num if it is number
    const _resultIsNumber = checkIfNumber(_result);
    if (_resultIsNumber.success) {
      returnMessage.result.num = Number(_resultIsNumber.result.num);
    } else {
      returnMessage.result.num = null;
    }
    returnMessage.result.bool = _result > 0;
    // set result string to string
    let s = _result?.toString();
    s = s?.replace(NEWLINE_REGEX, " ") || s || "";
    s = s.trim();
    returnMessage.result.string = s;
    returnMessage.success = true;
    return returnMessage;
  } catch (error) {
    returnMessage.result.string = expression;
    returnMessage.error.isError = true;
    returnMessage.error.message = error.message;
    return returnMessage;
  }
}

function removeLinebreaks(str) {
  return str.replace(NEWLINE_REGEX, "");
}
